import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

function LogOut() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Clear user data
        localStorage.removeItem("access_token");
        localStorage.removeItem("temp_token");
        localStorage.removeItem("user");
        localStorage.removeItem("userRole");

        console.log("Passing through location state:", location.state);
        // Preserve the original navigation state
        const from = location.state?.from || { pathname: '/dashboard' };
        
        // Redirect to login with the original location
        navigate("/login", {
            state: { from },  // Pass the entire location object
            replace: true
        });
    }, [navigate, location]);
}

export default LogOut;
